// Import model
import { HiddenFieldOptions } from '../models/HiddenFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for HiddenFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class HiddenFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a HiddenFieldOptions instance
   */
  static deserialize(json: string): HiddenFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a HiddenFieldOptions instance
   */
  static fromObject(obj: any): HiddenFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to HiddenFieldOptions');
    }


    const instance: HiddenFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _27B99Ed7: obj['_27b99ed7'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of HiddenFieldOptions instances
   */
  static deserializeArray(json: string): HiddenFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a HiddenFieldOptions instance to a JSON string
   */
  static serialize(instance: HiddenFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a HiddenFieldOptions instance to a plain object
   */
  static toObject(instance: HiddenFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_27b99ed7': instance._27B99Ed7,
    };
  }

  /**
   * Serializes an array of HiddenFieldOptions instances to a JSON string
   */
  static serializeArray(instances: HiddenFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
